module.exports = __webpack_public_path__ + "img/f54.7e1bb8f3.png";